export const SALES_REPORTS_DATA = {
  winLoss: {
    won: 7,
    lost: 11,
    winRate: '28%',
    avgWonSize: '$23.4K',
    avgLostSize: '$31.2K',
    topWinReason: 'Product fit + ROI demonstration',
    topLossReason: 'Pricing too high for stage',
  },

  repPerformance: [
    { name: 'David Chen', quota: 180000, attainment: 126000, pct: 70, deals: 4, pipeline: 170000, winRate: '32%', trend: '+3%' },
    { name: 'Sarah Kim', quota: 120000, attainment: 78000, pct: 65, deals: 3, pipeline: 42000, winRate: '30%', trend: '+5%' },
    { name: 'Mike Johnson', quota: 100000, attainment: 52000, pct: 52, deals: 2, pipeline: 82000, winRate: '18%', trend: '-4%', alert: true },
  ],

  monthlyTrend: [
    { month: 'Oct', closed: 84000, target: 120000 },
    { month: 'Nov', closed: 112000, target: 130000 },
    { month: 'Dec', closed: 142000, target: 140000 },
    { month: 'Jan', closed: 164000, target: 150000 },
  ],

  activityMetrics: [
    { label: 'Calls Made', value: '312', trend: '+8%', trendUp: true },
    { label: 'Emails Sent', value: '842', trend: '+15%', trendUp: true },
    { label: 'Meetings Held', value: '47', trend: '+22%', trendUp: true },
    { label: 'Proposals Sent', value: '18', trend: '+6%', trendUp: true },
    { label: 'Avg. Activities/Deal', value: '14', trend: '-2', trendUp: false },
    { label: 'Time to First Contact', value: '1.8 hrs', trend: '-22%', trendUp: true },
  ],

  insights: [
    { id: 'ri1', text: 'Win rate drops 40% when first demo happens more than 5 days after qualification. Recommend enforcing 3-day SLA for demo scheduling.', type: 'recommendation', time: '3 hrs ago' },
    { id: 'ri2', text: 'Mike Johnson\'s win rate (18%) is below team average. Analysis shows his deals stall in the Proposal stage — average 12 days vs team avg of 7.', type: 'alert', time: '5 hrs ago' },
    { id: 'ri3', text: 'Deals with ROI deck included close 2.3x faster than those without. Currently only 60% of proposals include one.', type: 'insight', time: 'Yesterday' },
    { id: 'ri4', text: 'December was the first month the team hit target. January on track to beat it by 9%. Momentum is building.', type: 'insight', time: 'Yesterday' },
  ],
};

export const REPORTS_CHAT_RESPONSES = {
  general: {
    text: "Here's your sales performance report.\n\nThe team closed $164K in January against a $150K target — first month beating quota since Q3. Win rate is 28%, pulled down by enterprise deals where pricing objections are the top loss reason.\n\nKey finding: deals with ROI decks close 2.3x faster, but only 60% of proposals include one. I've started auto-generating ROI sections for all new proposals.\n\nDavid and Sarah are performing well. Mike needs coaching on proposal-stage execution. Want me to create a coaching plan?",
  },
};
